import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectExternalProviderRequestDataSubmission = createSelector(
  [(state: AppState) => state.externalProvider.requestDataSubmission],
  state => state,
);
